import { useAppContainerContext } from '../contexts/AppContainerContext';
import { SideBarPageGroups } from '../types/enums';

export const useUpdatePageGroups = () => {
  const { openPageGroups, setOpenPageGroups } = useAppContainerContext();

  const updateOpenPageGroups = (pageGroup: SideBarPageGroups) => {
    const newOpenPageGroups = openPageGroups.slice();
    if (newOpenPageGroups.includes(pageGroup)) {
      const propIndex = newOpenPageGroups.indexOf(pageGroup);
      newOpenPageGroups.splice(propIndex, 1);
    } else {
      newOpenPageGroups.push(pageGroup);
    }

    setOpenPageGroups(newOpenPageGroups);
  };

  return { openPageGroups, updateOpenPageGroups };
};
